module.exports = __webpack_public_path__ + "static/krasty-alphabet-2015e14e7ae007b890a8697c44079ab5.svg";